import { BrowserRouter, Route, Routes, Link } from 'react-router-dom'

import HomePage from './pages/HomePage'
import PrivacyPolicy from './pages/PrivacyPolicy'
import DataPrivacy from './pages/DataPrivacy'
import Contact from './pages/Contact'
import NavBar from './components/NavBar';
import LogoBanner from './components/LogoBanner';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <div className='App background-container'>
        <LogoBanner />
        
        <div id="root">
          
          <div className='app-content'>
            <Routes>
              <Route path='/' element={<HomePage />}/>
              <Route path='/privacy-policy' element={<PrivacyPolicy />}/>
              <Route path='/data-privacy' element={<DataPrivacy />}/>
              <Route path='/contact' element={<Contact />}/>
              {/*}
              
              */}
            </Routes>
          </div>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;

